import _ from "lodash";
import React, { useCallback, useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import FullScreenLoader from "../../components/widgets/FullScreenLoader";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { startSearch } from "../../actions/single_search/accommodation_search";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { hotelsErrorMsgs } from "../../errors";
import { validateNewHotelSearch } from "../../components/MainSearchForm/hotel/helpers";
import { accSearchFormUpdate } from "../../actions/search/accommodation_search";
import { useApoAuth } from "../../hooks";

function recreateFormData(decoded_data) {
  const data = {
    rooms: decoded_data.rms,
    adults: decoded_data.rms.reduce((a, b) => a + b.adults, 0),
    children: decoded_data.rms.reduce((a, b) => a + b.children, 0),
    children_ages: _.flatten(decoded_data.rms.map((r) => r.children_ages)),
    checkIn: decoded_data.in,
    checkOut: decoded_data.out,
    destination_code: decoded_data.dst_c,
    destination_meta: decoded_data.dst_m,
  };
  return data;
}

const styles = createUseStyles({
  DeepHotelSearch: (props) => ({
    position: "absolute",
    background: "#FAFAFA",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    ..._.get(props, "customStyles.DeepHotelSearch", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
});
const DeepHotelSearch = ({ encoded_data }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({
    type,
    brand,
    objName: "DeepHotelSearch",
  });

  const classes = styles({ customStyles });

  function onError() {
    toast.warning(hotelsErrorMsgs.searchForm.init_search, { duration: 5000 });
    history.push("/");
  }

  if (!encoded_data) {
    onError();
  }

  var decoded_data = {};
  try {
    decoded_data = recreateFormData(JSON.parse(window.atob(encoded_data)));
  } catch (error) {
    onError();
  }

  const onFormUpdate = useCallback(
    ({ form }) => {
      dispatch(accSearchFormUpdate({ form }));
    },
    [dispatch]
  );

  const { source_entity, market_type } = useApoAuth();
  const onFormSearch = useCallback(() => {
    dispatch(
      startSearch({ redirect: true, history, source_entity, market_type })
    );
  }, [dispatch]);

  async function onSearch() {
    await onFormUpdate({
      form: {
        ...decoded_data,
        acc_search_type: "dest",
      },
    });
    onFormSearch();
  }

  // Execute search
  useEffect(() => {
    if (!source_entity) {
      return;
    }

    if (_.isEmpty(decoded_data)) {
      return;
    }

    if (
      !validateNewHotelSearch({
        destinationObj: { destination_code: decoded_data.destination_code },
        datesArray: [decoded_data.checkIn, decoded_data.checkOut],
      })
    ) {
      onError();
      return;
    }

    onSearch();
  }, [encoded_data, source_entity]);

  return (
    <div className={classes.DeepHotelSearch}>
      <FullScreenLoader />
    </div>
  );
};
DeepHotelSearch.propTypes = {
  encoded_data: PropTypes.string.isRequired,
};
export default DeepHotelSearch;
